
import { Component, Prop, Vue } from "vue-property-decorator";
import {IAppTable} from "@/shared/AppTable/interfaces/sort-table-data";
import {ICorp} from "@/modules/Corps/interfaces/corp.interface";
import {IDeviceStats} from "@/modules/DeviceStats/interfaces/device-stats.interface";

@Component({})
export default class TypeCell extends Vue {
  @Prop() cell: IAppTable.ITableProp;
  @Prop() entity: IDeviceStats.IEntity;
  @Prop() index: number;

  iconConfig = {
    1: { color: 'red',    icon: 'building-columns', },
    2: { color: 'red',    icon: 'clock', },
    3: { color: 'orange', icon: 'camera', },
    4: { color: 'orange', icon: 'display', },
    5: { color: 'orange', icon: 'solar-panel', },
    6: { color: '',       icon: 'calendar-days', },
  };
}
